import React, { Component, Children, createRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getDomPath } from '@thd-nucleus/experience-context';
import { UUID } from '../../utils';
import { publisher } from '../../publisher';
import '../Tab.style.scss';

const SPACE_STANDARD = 10;

class TabGroup extends Component {
  static getChildByType = (tab, type) => tab.props.children
    .find((child) => child.type.displayName === type);

  state = {
    activeTab: this.props.activeIndex,//eslint-disable-line
    id: UUID()
  };


  tabLineRef = React.createRef();

  tabRefs = [];

  nodeRef = createRef();

  componentDidMount = () => {
    const { activeTab } = this.state;
    if (this.tabRefs && this.tabRefs.length > 0) {
      this.tabRefs[activeTab].style.fontWeight = 'bold';
      this.updateTabsLine({ tab: this.tabRefs[activeTab] });
    }
  };

  onMouseEnterTab = (tab) => {
    const { currentTarget } = tab;
    const { activeTab } = this.state;
    if (activeTab === parseInt(currentTarget.value, 10)) {
      this.updateTabsLine({ tab: currentTarget, expand: true });
    }
  };

  onMouseLeaveTab = (tab) => {
    const { currentTarget } = tab;
    const { activeTab } = this.state;
    if (activeTab === parseInt(currentTarget.value, 10)) {
      this.updateTabsLine({ tab: currentTarget, expand: false });
    }
  };

  onClickTab = (tab) => {
    const { currentTarget } = tab;
    const { onChange } = this.props;
    this.setState((prevState) => {
      const nextActiveTab = parseInt(currentTarget.value, 10);
      let text = '';
      if (this.tabRefs && this.tabRefs.length > 0) {
        this.tabRefs[prevState.activeTab].style.fontWeight = 'normal';
        this.tabRefs[nextActiveTab].style.fontWeight = 'bold';
        text = this.tabRefs[nextActiveTab].innerText;
      }
      this.updateTabsLine({ tab: currentTarget, expand: true });
      const activeTabIndex = nextActiveTab;
      const path = getDomPath(this.nodeRef);

      publisher('click', { activeTabIndex, text, path });
      if (onChange) {
        onChange({ index: activeTabIndex });
      }
      return { activeTab: nextActiveTab };
    });
  };

  updateTabsLine = ({ tab, expand = false }) => {
    const { offsetLeft, offsetWidth } = tab;
    const line = this.tabLineRef.current;
    const widthOffset = expand ? 0 : 2 * SPACE_STANDARD;
    const leftOffset = expand ? SPACE_STANDARD : 0;
    line.style.width = `${offsetWidth - widthOffset}px`;
    line.style.left = `${offsetLeft - leftOffset}px`;
  };

  titleMapping = () => {
    const { activeTab, id } = this.state;
    const { children } = this.props;
    return (Children.map(children, (tab, index) => {
      const tabTitle = tab ? TabGroup.getChildByType(tab, 'TabTitle') : '';
      const titleId = `${id}-${index + 1}`;
      let cloneElement;
      if (tabTitle) {
        cloneElement = React.cloneElement(tabTitle, {
          key: `key-${titleId}`,
          id: `tab-${titleId}`,
          checked: activeTab === index,
          name: id,
          value: index,
          onClick: this.onClickTab,
          onMouseEnterTab: this.onMouseEnterTab,
          onMouseLeaveTab: this.onMouseLeaveTab,
          captureRef: (node) => {
            this.tabRefs[index] = node;
          }
        });
      }
      return cloneElement;
    }));
  };

  contentMapping = () => {
    const { activeTab, id } = this.state;
    const { children } = this.props;
    return (Children.map(children, (tab, index) => {
      const tabContent = tab ? TabGroup.getChildByType(tab, 'TabContent') : '';
      const contentId = `${id}-${index + 1}`;
      let cloneElement;
      if (tabContent) {
        cloneElement = React.cloneElement(tabContent, {
          key: `key-item-${contentId}`,
          id: `tab-item-${contentId}`,
          checked: activeTab === index
        });
      }
      return cloneElement;
    }));
  };

  render() {
    const { className } = this.props;
    return (
      <div className={classNames('tab-group', className)} ref={this.nodeRef}>
        <div className="tab-group__wrapper">
          {this.titleMapping()}
          <div ref={this.tabLineRef} className="tab-group__line tab-group__ease" />
        </div>
        <div className="tab-content">
          {this.contentMapping()}
        </div>
      </div>
    );
  }
}

TabGroup.displayName = 'TabGroup';

TabGroup.propTypes = {
  activeIndex: PropTypes.number,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func
};

TabGroup.defaultProps = {
  activeIndex: 0,
  className: null,
  onChange: null
};

export default TabGroup;
